import { render, staticRenderFns } from "./LiveTradingAccount.vue?vue&type=template&id=4f43d6c5"
import script from "./LiveTradingAccount.vue?vue&type=script&lang=js"
export * from "./LiveTradingAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports